import React from "react";
import defaultConfig from "config";
import { RedirectIcon, WalletIcon } from "components/icons";
import type { UserCredit } from "utils/creditUtils";

const Header: React.FC<{ creditInfo: UserCredit; userCredits: number }> = ({
  creditInfo,
  userCredits,
}) => {
  return (
    <div className="flex justify-between items-center mb:mb-4 border border-solid border-gray-300 px-4 py-2 md:py-4 w-full bg-[rgba(255,255,255,0.5)] sticky top-0 left-0 z-20 backdrop-blur-xl">
      <div className="flex flex-row items-center gap-[18px]">
        <img src="/icons/canvasai-logo.svg" alt="DeftGPT" />
        <a
          href={defaultConfig.canny_url}
          target="_blank"
          rel="noreferrer"
          className="text-[#4338CA] hidden flex-row items-center justify-center gap-1 font-medium md:flex hover:underline"
        >
          Request Feature?
          <span>
            <RedirectIcon />
          </span>
        </a>
      </div>
      <div className="flex flex-col space-y-1 md:flex-row items-end md:items-center md:space-y-0 md:space-x-6 md:pr-4">
        {creditInfo.nickname ? (
          <>
            <span className="text-[16px] text-right  md:text-[20px] font-semibold">
              Hi, {creditInfo.nickname}!
            </span>
            <div className="flex items-center space-x-2 ">
              <WalletIcon />
              <span className="text-[#4338CA] font-semibold text-[16px] py-[1px] rounded-[10px]">
                {userCredits || 0} credits left
              </span>
            </div>
          </>
        ) : (
          <span className="text-[#4338CA] font-semibold text-[16px] py-[1px] rounded-[10px] text-right">
            🎉 Get daily free credits!
          </span>
        )}
      </div>
    </div>
  );
};

export default Header;
